module.exports = __webpack_public_path__ + "static/media/trovalogo.82588c2c.png";